//@ts-check
import CONSTS from "shared/consts"
const { UI_RESULT_TYPES } = CONSTS

// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE 11 support for this feature
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined'
    ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    : string
}

// adapted from:
// https://github.com/mui-org/material-ui/blob/602cd124506f2f426a439eed2e8e43898b481537/packages/material-ui-lab/src/useAutocomplete/useAutocomplete.js#L18
export function generateSplitterFunction({ filterConfig = {}, getOptionLabel = (option) => option.title }) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    trim = false,
    matchFrom = "start"
  } = filterConfig

  return ({ option, inputValue = "" }) => {

    let optionTitle = getOptionLabel(option)
    if (!optionTitle) {
      return { beforeMatch: "" }
    }

    let optionTitleCleaned = optionTitle
    if (ignoreCase) {
      optionTitleCleaned = optionTitleCleaned.toLowerCase()
    }
    if (ignoreAccents) {
      optionTitleCleaned = stripDiacritics(optionTitleCleaned)
    }

    const defaultOutput = { beforeMatch: optionTitle }

    if (!inputValue) {
      return defaultOutput
    }

    let inputCleaned = trim ? inputValue.trim() : inputValue
    if (!inputCleaned) {
      return {
        beforeMatch: optionTitle,
      }
    }
    if (ignoreCase) {
      inputCleaned = inputCleaned.toLowerCase()
    }
    if (ignoreAccents) {
      inputCleaned = stripDiacritics(inputCleaned)
    }

    let startOfMatch
    let endOfMatch

    if (matchFrom === "start") {
      startOfMatch = optionTitleCleaned.indexOf(inputCleaned)
      endOfMatch = startOfMatch + inputCleaned.length
    } else {
      startOfMatch = optionTitleCleaned.lastIndexOf(inputCleaned)
      endOfMatch = startOfMatch + inputCleaned.length
    }

    if (startOfMatch === -1) {
      return defaultOutput
    }

    return {
      beforeMatch: optionTitle.slice(0, startOfMatch),
      matchingText: optionTitle.slice(startOfMatch, endOfMatch),
      afterMatch: optionTitle.slice(endOfMatch)
    }

  }
}

export function sortBySubCategory (itemA, itemB, propertyName) {
  let a = itemA
  let b = itemB
  if (propertyName){
    a = itemA[propertyName]
    b = itemB[propertyName]
  }
  const whichComesFirst = {
    A: -1, // i.e. a comes earlier
    B: 1, // i.e. a comes later
    same: 0 // neither must be earlier, leave order as is
  }
  if (a === "ERC-20") {
    return whichComesFirst.A // 'a' is ERC-20 so it comes before 'b'
  } else if (b === "ERC-20") {
    return whichComesFirst.B // 'b' is ERC-20 so it goes after 'a'
  } else if (a < b) { 
    return whichComesFirst.A // 'a' is first alphabetically
  } else if (a > b) { 
    return whichComesFirst.B // 'b' is first alphabetically
  } else {
    return whichComesFirst.same // 'a' and 'b' are the same, alphabetically
  }
}

export function getOutputItemStatus (outputItem) {
  if (outputItem.isInformational) {
    return UI_RESULT_TYPES.INFO
  } else if (String(outputItem.result).toLocaleLowerCase() == "n/a") {
    return UI_RESULT_TYPES.NOT_APPLICABLE
  } else if (outputItem.success) {
    return UI_RESULT_TYPES.PASS
  } else {
    return UI_RESULT_TYPES.FAIL
  }
}